 <div class="dwform">
 	<div class="dwform-cell-nopadding" style="min-width: 500px;">

        <div class="dwform-row-gap">

            <div class="dwform-row">
                <label class="label-field">Id:</label>
                <span class="form-required"></span>
                <label class="label-field-data" id="memberId">{{valId}}</label>
            </div>

        <div class="dwform-row-gap"></div>
        <div class="dwform-row">
           <label class="label-field">First Name:</label>
				<span class="form-required">*</span>
				<input class="input-field-long" id="firstName"
                       [disabled]="selectedRecord?.relationshipType === 'Self'"
					   style="text-transform: capitalize"
					   [(ngModel)]="valFirstName"
					   placeholder="<First Name>"
					   type="text">
        </div>
        <div class="dwform-row-gap"></div>
        <div class="dwform-row">
            <label class="label-field">Middle Name:</label>
            <span class="form-required"></span>
            <input class="input-field-long" id="middleName"
                   [disabled]="selectedRecord?.relationshipType === 'Self'"
                   style="text-transform: capitalize"
                   [(ngModel)]="valMiddleName"
                   placeholder="<Middle Name>"
                   type="text">
        </div>

		 <div class="dwform-row-gap"></div>
         <div class="dwform-row">
			    <label class="label-field">Last Name:</label>
			    <span class="form-required">*</span>
			    <input class="input-field-long" id="lastName"
                       [disabled]="selectedRecord?.relationshipType === 'Self'"
			           style="text-transform: capitalize"
			           [(ngModel)]="valLastName"
			           placeholder="<Last Name>"
			           type="text">
		</div>

        <div class="dwform-row-gap"></div>

            <label class="label-field">Relationship Type:</label>

            <span class="form-required" *ngIf="selectedRelationship !== 'Self'">*</span>
            <span class="form-required" *ngIf="selectedRelationship === 'Self'"></span>

            <dw-dropdown [id]="'relationshipTypeId'" *ngIf="selectedRelationship !== 'Self' || editPrimaryApplicant"
                         [selectedItem]="valRelationship"
                         [controlWidth]="'230px'"
                         [dataSource]="relationshipList"
                         (itemSelected)="valRelationship=$event; doRelationshipTypeSelected($event)">
            </dw-dropdown>

            <span *ngIf="selectedRelationship === 'Self' && !editPrimaryApplicant">Self </span>

        </div>



        <div class="dwform-row">
            <label class="label-field">Gender:</label>
            <span class="form-required"></span>
            <dw-dropdown [selectedItem]="valGender"
                         [controlWidth]="'150px'"
                         [dataSource]="genderList"
                         (itemSelected)="valGender=$event">
            </dw-dropdown>
        </div>

        <div class="dwform-row-gap"></div>

        <div class="dwform-row" *ngIf="viewDOB">
            <label class="label-field">Date of Birth:</label>
            <span class="form-required" *ngIf="valRelationship !== 'Advocate'">*</span>
            <span class="form-required" *ngIf="valRelationship === 'Advocate'"></span>

            <input class="input-field-short" id="dob"
                    [disabled]="advocateFlag || !editDOB"
                   style="width:90px"
                   mask='9999-99-99'
                   matTooltip="format is YYYY-MM-DD"
                   matTooltipPosition="right"
                   [dropSpecialCharacters]="false"
                   showMaskTyped="true"
                   [(ngModel)]="valDob" placeholder="<Date of Birth>">
        </div>

        <div class="dwform-row-gap"></div>
        <div class="dwform-row" *ngIf="viewComment">
            <label class="label-field" style="vertical-align: top;">Comments:</label>
            <span class="form-required">*</span>
            <textarea class="input-field-long text-area-input" id="memberComments"
                   style="height:50px; resize: none;"
                   [(ngModel)]="valMemberComments"
                   [disabled]="!editComment"
                   placeholder="<Comments>"
                   type="text"></textarea>
        </div>


    </div>
 </div>
  <!----------------------->
  <!-- ERROR LINE --------->
  <!----------------------->
  <div class="error-line" [hidden]='!strErr.length'
       style="text-align:left; bottom: 45px;">{{strErr}}</div>
  <!----------------------->
  <!-- SAVE STRIP        -->
  <!----------------------->
  <div class="save-close-strip" style="bottom: 10px;">

      <button mat-button class="command-button" [disabled]="!submitEnabled"
              (click)="submitRecord()" matTooltip="Save the record"
              mat-button>
          <mat-icon>check_circle_outline</mat-icon>
          Submit
      </button>
      <button mat-button class="command-button" 
              (click)="cancelSubmitRecord()" matTooltip="Close window" mat-button>
          <mat-icon>highlight_off</mat-icon>
          Cancel
      </button>
  </div>
